<div class="container" role="tablist">
	<div class="tab" role="tab" [attr.tabindex]="activeTab && tab.id === activeTab.id ? 0 : -1"
		*ngFor="let tab of tabs; trackBy: trackById" (click)="onClickTab(tab, $event)"
		(keydown)="onTabKeydown($event, tab)" [ngClass]="{
			active: activeTab && tab.id === activeTab.id
		}" [attr.data-testid]="'tab-' + tab.id" [attr.aria-selected]="activeTab && tab.id === activeTab.id">
		{{ tab.label }}
	</div>
</div>